// Anonymous public-site analytics client.
// Does NOT collect names, emails, phone, appointment details, medical, or PII.
// - session_id is a random ID kept in sessionStorage (rotates when tab session ends)
// - No IP address is sent; the browser's network layer supplies it to the server
//   but the server intentionally does not store it.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SESSION_KEY = "ccchaps_pa_sid";
const SEEN_SECTIONS_KEY = "ccchaps_pa_seen_sections";

function _randId(len = 22) {
  const arr = new Uint8Array(len);
  (window.crypto || window.msCrypto).getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(36).padStart(2, "0")).join("").slice(0, len);
}

export function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = _randId(22);
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "nosid";
  }
}

function _seenSections() {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(SEEN_SECTIONS_KEY) || "[]"));
  } catch {
    return new Set();
  }
}
function _persistSeenSections(set) {
  try {
    sessionStorage.setItem(SEEN_SECTIONS_KEY, JSON.stringify(Array.from(set)));
  } catch {
    /* ignore */
  }
}

// Fire-and-forget. Never throws. Never blocks navigation.
function _send(payload) {
  try {
    axios.post(`${API}/analytics/track`, payload, { withCredentials: false }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export function trackPageView(pathname) {
  if (!pathname) return;
  if (pathname.startsWith("/care-portal") || pathname.startsWith("/admin")) return;
  _send({ type: "page_view", path: pathname, session_id: getSessionId() });
}

export function trackSection(sectionKey, pathname) {
  if (!sectionKey) return;
  const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/");
  if (path.startsWith("/care-portal") || path.startsWith("/admin")) return;
  const seen = _seenSections();
  const dedupeKey = `${path}::${sectionKey}`;
  if (seen.has(dedupeKey)) return;
  seen.add(dedupeKey);
  _persistSeenSections(seen);
  _send({ type: "section_view", path, section_key: sectionKey, session_id: getSessionId() });
}

export function trackCTA(ctaKey, pathname) {
  if (!ctaKey) return;
  const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/");
  if (path.startsWith("/care-portal") || path.startsWith("/admin")) return;
  _send({ type: "cta_click", path, cta_key: ctaKey, session_id: getSessionId() });
}
